import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditAssignationActionContext } from "./EditAssignationActionContext";

function useGet() {
  const { setElement, setShowModal } = useContext(EditAssignationActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    assignationId: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get(`assignments/${id}/assignation`, assignationId)
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
